"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.hashPassword = exports.sha256base64url = exports.sha256hex = void 0;
const sha256_1 = __importDefault(require("./sha256"));
/**
 * @param {string} data
 * @return {string}
 */
function sha256hex(data) {
    const hashedData = new sha256_1.default().update(data).digest('hex');
    return /** @type {string} */ (hashedData);
}
exports.sha256hex = sha256hex;
/**
 * @param {string} data
 * @return {string}
 */
function sha256base64url(data) {
    const hashedData = new sha256_1.default().update(data).digest('base64url');
    return /** @type {string} */ (hashedData);
}
exports.sha256base64url = sha256base64url;
/**
 * @param {string} password
 * @return {{ digest: string, algorithm: string }}}
 */
function hashPassword(password) {
    const hashedPassword = {
        digest: sha256hex(password),
        algorithm: 'sha-256',
    };
    return hashedPassword;
}
exports.hashPassword = hashPassword;
exports.default = sha256_1.default;
//# sourceMappingURL=index.js.map